export default __webpack_public_path__ + "static/media/Publish.a7f5f0de.svg";